fragment OrderFragment on Order {

    id

    items {
        ...OrderItemFragment
    }

    customer_id
    customer {
        ...CustomerFragment
    }

    customer_order_no
    customer_notes

    ext_customer_id
    ext_company_id

    wc_items
    wc_logotypes

    currency
    status

    billing_address {
        ...BillingAddressFragment
    }

    shipping_address {
        ...ShippingAddressFragment
    }

    subtotal
    total
    taxes
    tax_rate
    shipping

    order_sequence
    order_number

    old_order_id

    created_at
    updated_at

}